// Dev-only override for where the sensor check-in SSE connects.
//
// A dev2/dev build points everything (REST + the scanner SSE) at its own VPC
// (development.airplate.dk), which usually has no real sensors checking in.
// This lets a developer, ONLY on a dev host, redirect just the scanner
// check-in stream to the production stream (ws.airplate.dk) to test the UI
// against live sensor data. The override is read at SSE connect-time and is
// hard-gated to dev hostnames, so it can never affect the production app.

const KEY = "airplate.dev.scannerSseHost";

// The override is honored ONLY when the dashboard is served from one of these.
// staging.airplate.dk is a non-production test host too — its dev backend has
// no live sensors, so it needs the same redirect. The production app
// (app.airplate.dk) is deliberately excluded.
const DEV_HOSTS = ["dev.airplate.dk", "dev2.airplate.dk", "staging.airplate.dk"];

/** Production sensor-SSE host (the real check-in stream). */
export const SCANNER_SSE_PROD_HOST = "ws.airplate.dk";

export function isDevHost(): boolean {
  return (
    typeof window !== "undefined" &&
    DEV_HOSTS.includes(window.location.hostname)
  );
}

/** The override host, or null. Always null off a dev host. */
export function getScannerSseHostOverride(): string | null {
  if (!isDevHost()) return null;
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function setScannerSseHostOverride(host: string | null): void {
  try {
    if (host) localStorage.setItem(KEY, host);
    else localStorage.removeItem(KEY);
  } catch {
    // localStorage unavailable (private mode etc.) — override just won't stick.
  }
}
